import { AutogenModelRate, AutogenRowRate } from "./autogen/AutogenModelRate";

export class ModelRate extends AutogenModelRate<RowRate> {
	constructor() {
		super(RowRate);
	}
}

export class RowRate extends AutogenRowRate {
}